<template>
  <button @click="pay()" :disabled="disabled">
    Pay <money-string v-bind="$props" />
  </button>
</template>

<script>
import { PAYSTACK_URL, PAYSTACK_KEY } from '@/utilities/payment';
import MoneyString from '@/components/MoneyString.vue';

export default {
  name: 'PaystackButton',
  props: {
    amount: Number,
    currency: String,
    email: String,
    disabled: Boolean,
  },
  data() {
    return {
      scriptLoaded: false,
    };
  },
  beforeMount() {
    const vm = this;
    const script = document.createElement('script');
    script.src = PAYSTACK_URL;
    script.onload = () => {
      vm.scriptLoaded = true;
    };
    document.body.append(script);
  },
  components: {
    MoneyString,
  },
  methods: {
    charge({ email, amount, currency }) {
      return new Promise((resolve, reject) => {
        window.PaystackPop.setup({
          key: PAYSTACK_KEY[process.env.NODE_ENV],
          email,
          amount,
          currency,
          callback(response) {
            resolve(response);
          },
          close() {
            reject();
          },
        }).openIframe();
      });
    },
    pay() {
      this.charge(this.$props).then((response) => {
        // To do: Verify on cloud function
        this.$emit('complete', {
          processor: 'paystack',
          response,
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
